/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import sass from "pages/StepPages/StepFour/IndexPage/indexPage.module.sass";
import {useLocation, useParams} from "react-router-dom";
import {IThreadList} from "pages/StepPages/StepFour/models/threadModel";
import HeadPage from "pages/StepPages/StepFour/HeadPage";
import Legend from "pages/StepPages/StepFour/HeadPage/Legend";
import InputTemp from "components-new/InputTemp";
import {Search} from "components-new";
import ColumnData from "pages/StepPages/StepFour/IndexPage/ColumnData";
import RowData, {AscType} from "pages/StepPages/StepFour/IndexPage/RowData";
import {ReactComponent as SvgUsualTable} from "images/table.svg";
import {ReactComponent as SvgGroupTable} from "images/groups.svg";
import {useAppSelector} from "toolkit/hooks";
import useDebounce from "hooks/useDebounce";
import {usePaginationWithIntersection as usePaginationColumn} from "hooks/usePaginationWithIntersection";
import Button from "../../../../components/shared/Button";
import {BUTTON_VARIANTS} from "../../../../components/shared/Button/Button";
import {ModalCreateTemplate} from "../../StepFive/SelectionCategories/ModalCreateTemplate";

interface IParams {
	part: number;
	count: number;
	filter: null | "INITIAL" | "MODEL" | "CATEGORIZED" | "REPEATED";
	order_column: null | "object" | "activity" | "fill";
	order_value: AscType;
	query: string;
}
export interface IOptionsSort {
	key: null | "object" | "activity" | "fill";
	ask: AscType;
}

const IndexPage = () => {
	const location = useLocation();

	const [stepOne, setStepOne] = useState<boolean | null>(null);

	const [stepOneParams, setStepOneParams] = useState<IParams>({
		part: 1,
		count: 20,
		filter: null,
		order_column: null,
		order_value: null,
		query: "",
	});

	const [patternModal, setPatternModal] = useState<{
		active: boolean;
		data: number | null;
		mode: "create" | "select";
	}>({
		active: false,
		mode: "select",
		data: null,
	});

	const closePatternModal = () => setPatternModal((prevState) => ({ ...prevState, active: false, data: null }));

	useEffect(() => {
		setStepOne(location.pathname.replace(/.+(4\.\d)$/, "$1") === "4.1");
	}, [location.pathname]);

	const changeSortAskDescOne = useCallback(
		(sort: IOptionsSort) => {
			if (sort.ask === null) {
				setStepOneParams((prevState) => ({ ...prevState, order_column: null, order_value: null, part: 1 }));
			} else {
				setStepOneParams((prevState) => ({ ...prevState, order_column: sort.key, order_value: sort.ask, part: 1 }));
			}
			setIsFinally(false);
			setFetch(true);
		},
		//eslint-disable-next-line
		[stepOne],
	);

	const params = useParams();

	const [tables, setTables] = useState<IThreadList[]>([]);

	const [tablesFactor, setTablesFactor] = useState<"row" | "column">("row");
	const changeFactor = useCallback(
		(e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
			const factor = e.currentTarget.dataset.factor as "row" | "column";
			if (stepOne === null) return;
			if (factor !== tablesFactor) {
				setTablesFactor(factor);
				setStepOneParams((prevState) => ({ ...prevState, part: 1, order_value: null, order_column: null }));
				setIsFinally(false);
				setFetch(true);
			}
		},
		//eslint-disable-next-line
		[stepOne, tablesFactor],
	);

	// useEffect(() => {
	// 	setStepOneParams((prevState) => ({ ...prevState, part: 1, order_value: null, order_column: null, factor: null }));
	// }, [params.threadId]);

	const list: { id: number; value: any; name: string }[] = useMemo(() => {
		if (stepOne) {
			return [
				{ id: 0, value: null, name: "По умолчанию" },
				{ id: 1, value: "INITIAL", name: "Ожидает утверждения модели угроз" },
				{ id: 2, value: "MODEL", name: "Модель угроз утверждена" },
				{ id: 3, value: "CATEGORIZED", name: "Объект получил категорию" },
				{ id: 6, value: "REPEATED", name: "Повторное категорирование" },
			];
		} else {
			return [
				{ id: 0, value: null, name: "По умолчанию" },
				{ id: 4, value: "", name: "Расчет готов" },
				{ id: 5, value: "", name: "Расчет не производился" },
				{ id: 6, value: "", name: "Повторное категорирование" },
			];
		}
	}, [stepOne]);
	const [options, setOptions] = useState<{
		active: { id: number; value: null | "INITIAL" | "MODEL" | "CATEGORIZED" | "REPEATED"; name: string };
		list: { id: number; value: null | "INITIAL" | "MODEL" | "CATEGORIZED" | "REPEATED"; name: string }[];
	}>({
		active: { id: 0, value: null, name: "По умолчанию" },
		list: [],
	});
	useEffect(() => {
		setOptions((prevState) => ({ ...prevState, list }));
	}, [list]);

	const [search, setSearch] = useState("");

	const name = useAppSelector((state) => state.organizations.selectedOrganization?.fullName);

	const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = e.target;
		setSearch(value);
	};

	const query = useDebounce(search, 400);

	useEffect(() => {
		if (!patternModal.active) {
			setStepOneParams((prevState) => ({...prevState, query, part: 1}));
			setIsFinally(false);
			setFetch(true);
		}
		//eslint-disable-next-line
	}, [query, patternModal.active]);

	const changeFilter = (active: any) => {
		setOptions((prevState) => ({ ...prevState, active }));
		setStepOneParams((prevState) => ({ ...prevState, part: 1, filter: active.value }));
		setIsFinally(false);
		setFetch(true);
	};

	const wrapper = useRef<HTMLElement | null>(null);

	const lastElementRow = useRef<HTMLElement | null>(null);
	const lastElementColumn = useRef<HTMLElement | null>(null);

	const lastTarget = useMemo(() => {
		return tablesFactor === "row" ? lastElementRow : lastElementColumn;
	}, [tablesFactor]);

	const thenHandler = useCallback(
		(data: IThreadList[]) => {
			const upPart = (prevState: typeof stepOneParams) => ({ ...prevState, part: prevState.part + 1 });
			if (stepOneParams.part === 1) {
				if (data.length === stepOneParams.count) {
					setStepOneParams(upPart);
				}
				if (!data.length || data.length < stepOneParams.count) {
					setIsFinally(true);
				}
				setTables(data);
			} else {
				setTables((prevData) => [...prevData, ...data]);
				if (data.length < stepOneParams.count) {
					setIsFinally(true);
				} else {
					setStepOneParams(upPart);
				}
			}
		},
		//eslint-disable-next-line
		[stepOneParams],
	);

	const { setFetch, setIsFinally } = usePaginationColumn({
		link: `/organization/${params.organizationId}/threats`,
		params: stepOneParams,
		then: thenHandler,
		dependencies: [stepOne !== null, params.organizationId],
		ref: wrapper,
		lastTarget,
		margin: "60px",
		catchHandler: () => {
			setIsFinally(true);
		},
	});

	return (
		<>
			<HeadPage
				subTitle={name ? name : ""}
				topTitle={stepOne ? "4. Формирование модели угроз" : "4.2 Расчет экономического ущерба"}
				title={stepOne ? "Выбор объекта для формирования модели угроз" : "Работа с расчетом экономического ущерба"}>
				<div className={sass.search_wrapper}>
					<div className={sass.search}>
						Фильтрация:
						<InputTemp
							currentValue={options.active}
							value={options.active.name}
							onSelect={changeFilter}
							className={sass.input}
							options={options.list}
							field={["name"]}
							type={"select"}
						/>
					</div>
					<Button variant={BUTTON_VARIANTS.OUTLINED} onClick={()=>setPatternModal({active:true,data:null,mode:'select'})}>
						Применить шаблон
					</Button>
					<Search className={sass.inputSearch} searchValue={search} handleSearch={handleSearch} />
					<div className={sass.factor}>
						<SvgUsualTable
							className={sass[`active-${tablesFactor === "row"}`]}
							data-factor={"row"}
							onClick={changeFactor}
						/>
						<SvgGroupTable
							className={sass[`active-${tablesFactor === "column"}`]}
							data-factor={"column"}
							onClick={changeFactor}
						/>
					</div>
				</div>
			</HeadPage>
			<ModalCreateTemplate step={4} target={patternModal} close={closePatternModal} />
			<Legend stepOne={stepOne} factor={tablesFactor} />
			{tablesFactor === "row" ? (
				<RowData
					scrollWrapper={wrapper}
					lastElement={lastElementRow}
					sort={changeSortAskDescOne}
					stepOne={stepOne}
					data={tables}
				/>
			) : (
				<ColumnData
					scrollWrapper={wrapper}
					lastElement={lastElementColumn}
					sort={changeSortAskDescOne}
					stepOne={stepOne}
					data={tables}
				/>
			)}
		</>
	);
};

export default IndexPage;
